<template>
    <v-navigation-drawer stateless value="true" class="catalog-navigation catalog-navigation--max">
        <v-toolbar text color="white">
            <v-toolbar-title>
                <v-text-field
                    label="Поиск"
                    solo
                    text
                    single-line
                    class="mb-0"
                    prepend-icon="search"
                    hide-details/>
            </v-toolbar-title>
            <v-spacer/>
            <v-menu bottom left>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                </template>

                <v-list>
                    <v-list-item @click="addStockC">
                        <v-list-item-title>Добавить</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-toolbar>
        <v-list v-if="getStockCatalogs.length > 0" class="v-list--booking">
            <v-list-item
                :key="stockC.id"
                active-class="active"
                v-if="!stockC.deleted"
                v-for="stockC in getStockCatalogs"
                @click="editStockC(stockC.id)"
                :class="`v-list--booking_state f-width ${$route.params.stockCatalogId === stockC.id ? 'active' : ''}`">
                <v-list-item-title v-text="stockC.name"/>
                <v-list-item-action>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon @click.prevent="stockCChangeStatus(stockC.id, stockC.status)" v-on="on">
                                <v-icon>{{ stockC.status ? 'remove_red_eye' : 'visibility_off' }}</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ stockC.status ? 'Активен' : 'Не активен' }}</span>
                    </v-tooltip>
                </v-list-item-action>
            </v-list-item>
        </v-list>
        <empty v-else/>
    </v-navigation-drawer>
</template>

<script>
    import { mapGetters } from 'vuex'
    import StockCatalog from '../../../../api/stockcatalog'
    import Empty from '../../../../components/Loader/Empty'

    export default {
        name: 'stockCatalogNavigation',
        components: { Empty },
        methods: {
            addStockC () {
                this.$router.push({ name: 'addStockCatalog' })
            },
            editStockC (id) {
                this.$router.push({
                    name: 'editStockCatalog',
                    params: { stockCatalogId: id }
                })
            },
            stockCChangeStatus (id, status) {
                StockCatalog
                    .changeStatus({
                        id,
                        status
                    })
                    .then(response => {
                        this.$store.commit('changeStockCatalogStatus', response.data.data)
                        this.$store.commit('showSnackbar', {
                            text: 'Статус акции изменен',
                            color: 'success'
                        })
                    })
                    .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
            }
        },
        computed: {
            ...mapGetters([
                'getStockCatalogs'
            ])
        }
    }
</script>
